<mat-icon style="float: right"><span (click)="clear()">clear</span></mat-icon>
<!-- *ngIf="maticon" -->
<form *ngIf="login" [formGroup]="loginForm">
  <div class="accordion-class">
    <h6>Customer Login</h6>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <mat-form-field>
        <mat-label>Mobile</mat-label>
        <input
          matInput
          formControlName="mobile"
          minlength="10"
          maxlength="10"
          required
          (keypress)="validateNumber($event)"
        />
        <mat-error>Please Enter Valid Mobile Number</mat-error>
      </mat-form-field>
    </div>
  </div>
  <!-- <i class="fa fa-spinner fa-spin"></i> -->
  <button
    [class.spinner]="loading"
    [disabled]="loading"
    type="button"
    class="button buttonBlue"
    (click)="sendOTP()"
  >
    Send OTP
  </button>
</form>
<form *ngIf="otp" [formGroup]="otpForm">
  <div class="accordion-class">
    <h6>Login</h6>
    <mat-divider></mat-divider>
  </div>
  <div class="login">
    <p>Verify Your Mobile Number</p>
    <h5>{{ loginResponse?.mobile }}</h5>
  </div>
  <div class="group otp-field">
    <ng-otp-input
      [config]="{ length: 4 }"
      (onInputChange)="onOtpChange($event)"
    ></ng-otp-input>
    <p *ngIf="loginResponse?.code">Code:{{ loginResponse.code }}</p>
  </div>
  <a class="resent-btn" (click)="resendOTP()">Resend otp</a>
  <div *ngIf="otpWrongErrorMsg" class="otpMsg">
    Please enter the correct otp
  </div>
</form>

<!-- ------------ Sign Up Form ------------- -->

<div *ngIf="signUp">
  <form [formGroup]="signupForm">
    <div class="accordion-class">
      <h6>Signup</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container mt-0">
      <div class="group mb-0">
        <mat-form-field class="mt-3">
          <mat-label>Name</mat-label>
          <input matInput formControlName="username" required />
          <mat-error>Please Enter Valid Name</mat-error>
        </mat-form-field>
        <mat-form-field class="mt-3">
          <mat-label>Mobile</mat-label>
          <input
            matInput
            formControlName="mobile"
            [(ngModel)]="verifyData.mobile"
            readonly
          />
          <img src="../../../assets/img/tick-verify.svg" />
          <mat-error>Please Enter Valid Mobile Number</mat-error>
        </mat-form-field>
        <!-- <mat-form-field class="mt-3">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" />
          <mat-error>Please Enter Valid Email ID</mat-error>
        </mat-form-field> -->
      </div>
    </div>
    <button type="button" class="button buttonBlue" (click)="Next()">
      Next
    </button>
  </form>
</div>

<!-- -------------------- GST Form ------------- -->

<div *ngIf="gst">
  <form [formGroup]="GSTForm">
    <div class="accordion-class">
      <h6>Signup</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container mt-0 mb-2">
      <div class="group mb-0">
        <mat-form-field class="mt-3">
          <mat-label>Designation(optional)</mat-label>
          <input matInput formControlName="designation" />
        </mat-form-field>
        <mat-form-field
          class="mt-3"
          [class.field-locked]="isGstVerified"
          [matTooltip]="isGstVerified ? 'Non-editable' : ''"
          [matTooltipDisabled]="!isGstVerified"
          matTooltipPosition="above"
          [title]="isGstVerified ? 'Non-editable' : ''"
        >
          <mat-label>Company(optional)</mat-label>
          <input
            matInput
            formControlName="company_name"
            [readonly]="isGstVerified"
            [class.input-locked]="isGstVerified"
            [matTooltip]="isGstVerified ? 'Non-editable' : ''"
            [matTooltipDisabled]="!isGstVerified"
            matTooltipPosition="above"
            [title]="isGstVerified ? 'Non-editable' : ''"
          />
        </mat-form-field>
        <div class="field-verify-wrapper mt-3">
          <mat-form-field>
            <mat-label>GST(optional)</mat-label>
            <input
              matInput
              toUppercase
              appAlphanumericOnly
              formControlName="gst"
              maxlength="15"
              (input)="onGstChange()"
            />
          </mat-form-field>
          <div class="verify-addon" *ngIf="GSTForm.controls['gst'].value">
            <div *ngIf="!isGstVerified && !isGstVerifying">
              <a
                *ngIf="GSTForm.controls['gst'].value?.length === 15"
                (click)="verifyGST()"
                class="verify-action-link"
                title="Verify GST with Master India"
                >Verify GST</a
              >
            </div>
            <div *ngIf="isGstVerifying" class="d-flex align-items-center">
              <div class="inline-spinner"></div>
              <span style="font-size: 11px; color: #64748b; margin-left: 6px;">Verifying...</span>
            </div>
            <div *ngIf="isGstVerified" class="d-flex align-items-center">
              <div class="verified-badge-inline" title="GST Verified with Master India">
                <img src="../../../assets/img/tick-verify.svg" alt="Verified" />
                <span>Verified</span>
              </div>
              <a
                (click)="editGst()"
                class="change-gst-link"
                title="Click to change and re-verify GST"
                style="margin-left: 8px; font-size: 12px; color: #f58634; font-weight: 500; cursor: pointer; text-decoration: underline;"
                >Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="image-upload-view-area">
      <img class="upload_img_size" [src]="profileImage" *ngIf="profileImage" />
    </div>
    <div *ngIf="!profileImage" class="image-upload-area">
      <p>Select your profile picture</p>
      <span (click)="uploadImage.click()" class="image">
        <img src="../../../assets/img/profile-upload.svg" />
      </span>
      <input
        #uploadImage
        type="file"
        formControlName="profile_pic"
        (change)="onChange($event)"
        hidden
      />
    </div>
    <div class="popupbtn">
      <a *ngIf="!profileImage" (click)="skip()">Skip</a>
      <button type="button" class="button buttonBlue" (click)="Register(1)">
        Register
      </button>
    </div>

    <!-- <div class="image-upload-view-area">
      <img class="upload_img_size" src="{{ profileImage }}" />
    </div>
    <div *ngIf="profileImg" class="image-upload-area">
      <p>Select your profile picture</p>
      <span (click)="uploadImage.click()" class="image"
        ><img src="../../../assets/img/profile-upload.svg"
      /></span>
      <input
        #uploadImage
        type="file"
        formControlName="profile_pic"
        (change)="onChange($event)"
        hidden
      />
    </div>
    <div class="popupbtn">
      <a (click)="skip()">Skip</a>
      <button type="button" class="button buttonBlue" (click)="Register(1)">
        Register
      </button>
    </div> -->
  </form>
</div>

<!-- -------------------- Retrieve Account ------------- -->

<div *ngIf="retrieve_acc" class="container">
  <p>
    {{ message }}
  </p>
  <div class="retrieve_btn mt-3">
    <button class="yes_btn" (click)="restoreAccount()">
      Restore My Account
    </button>
  </div>
  <p class="mt-3 p_or">or</p>
  <h6 class="text" (click)="newLogin()">Login with New Mobile No</h6>
</div>
